import api from "../api/config";

export const paymentsAPI = {
  getConfig: async () => {
    try {
      const res = await api.get("/payments/config");
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || "Failed to load config" };
    }
  },

  createCheckoutSession: async (plan) => {
    try {
      const res = await api.post("/payments/create-checkout-session", { plan });
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || "Failed to create session" };
    }
  },

  getSubscriptionStatus: async () => {
    try {
      const res = await api.get("/payments/subscription-status");
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || "Failed to get status" };
    }
  },

  createCustomerPortal: async () => {
    try {
      const res = await api.post("/payments/customer-portal");
      return { success: true, data: res.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.error || "Failed to create portal" };
    }
  },
};

export default paymentsAPI;
